import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../../service/server/server.service';
import { InsertModelComponent } from '../../repairman/insert-model/insert-model.component';
import { MessageService } from '../../service/message/message.service';


@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss']
})
export class ModulesComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public dir: any = JSON.parse(<any>localStorage.getItem('dir'));
  public loading: boolean = false;
  public list_record: any = [];
  public page_number_first: number = 1;
  public count_total: number = 1;
  public list_record_length = 1;
  public page: number = 1;
  public code_id: number = 1046;
  public subscription: Subscription | any;
  public title!: string;
  public page_number_second!: number;
  public id!: number;
  public table!: any;
  public user_id!: number;
  public row_id!: any;
  public where!: string;
  public creator!: string;
  public search!: string;
  public record_id!: number;
  public obj!: any;
  public brand!: number;
  public device!: number;
  public pre_status!: boolean;
  public next_status!: boolean;
  public new_status!: boolean;
  public mat_table_selectedRow!: any;
  public dataSource!: any;
  public displayedColumns = ['row', 'brand', 'model', 'title', 'title2', 'tax_percent', 'place', 'account_bank_name', 'account_branch_name', 'account_branch_number', 'wharehouse_group', 'wharehouse_cate'];

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public matDialogRef: MatDialogRef<ModulesComponent>,
    public dialog: MatDialog
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    if (dialog_data) {
      this.id = dialog_data.id;
      this.brand = dialog_data.brand;
      this.device = dialog_data.device;
      this.where = dialog_data.where;
      this.creator = dialog_data.creator;
      if (dialog_data.code_id) this.code_id = dialog_data.code_id;
      if (dialog_data.server) this.server = dialog_data.server;
      this.record_id = dialog_data.record_id;
      this.obj = dialog_data.obj;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_service();
  }
  get_service(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1045,
      'id': this.id,
      'user_id': this.user_id,
      'lang': this.lang
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1 && res['num'] > 0) {
          this.title = res['result'][0].site_services_title;
          this.table = res['result'][0].site_services_table;
          if (this.id == 171) this.title = "انتخاب کالا";
          this.which_get_data(1, 1);
        }//end if 
        else if (res['status'] == 1 && res['num'] == 0) {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_bg(row_id: number) {
    this.row_id = row_id;
  }
  arrowDownEvent() {
    //this.row_id = row_id;
  }
  which_get_data(type: number, page: number): any {
    if (!this.creator) {
      return false;
    }
    if (this.code_id == 1046) {
      this.get_data(type, page);
    } else {
      this.get_data2(type);
    }
  }
  get_data(type: number, page: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (page == 1 || type == 2) { this.page = 1; }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 50); }
    if (page == 3) { this.page = this.page - 1; }
    if (type == 1) this.loading = true;
    var obj = {
      'address': 1046,
      'page': this.page,
      'lang': this.lang,
      'id': this.id,
      'table': this.table,
      'where': this.where,
      'creator': this.creator,
      'search': this.search,
      'user_id': this.user_id,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.list_record_length = this.list_record.length;
          this.count_total = res['count'];
          this.pages(0);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }//end recieve_data
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 50 - 49;
    this.page_number_second = this.page * 50;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 50) { this.page_number_second = this.count_total; this.next_status = true }//end if
    else { this.next_status = false; }
  }
  get_data2(type: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (type == 1) this.loading = true;
    var obj = {
      'address': this.code_id,
      'lang': this.lang,
      'record_id': this.record_id,
      'obj': this.obj,
      'search': this.search,
      'creator': this.creator,
      'user_id': this.user_id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }//end recieve_data
  select(id: number, title: string, title2: string) {
    var title = title;
    this.matDialogRef.close({ id: id, title: title });
  }//end select
  insert_model() {
    const dialogRef = this.dialog.open(InsertModelComponent, {
      'width': '40rem',
      'height': 'auto',
      'data': { brand: this.brand, device: this.device, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.list_record.unshift({ title: res.model_title, id: res.model });
          this.dataSource.data = this.list_record;
        }
      }
    )
  }
  save_model(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.device || !this.brand) {
      var pe_message = "برای ثبت مدل باید دستگاه و برند مشخص باشد";
      var en_message = "To register the model, the device and brand must be specified";
      this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      return false;
    }
    var obj = {
      address: 1671,
      user_id: this.user_id,
      status_id: 1,
      device: this.device,
      brand: this.brand,
      title: this.search,
      creator: this.creator
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close({ id: res['result'][0].repairman_model_id, title: res['result'][0].repairman_model_title })
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "این عنوان مدل برای این دستگاه و برند قبلا در سیستم ثبت شده است";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}